export default __webpack_public_path__ + "static/news12-c9148b4d97934f8d4c4a77109d519465.jpeg";